<script>
  import Input from "./components/Input.svelte";
  import Logo from "./components/Logo.svelte";
  import WhatsApp from "./components/WhatsApp.svelte";
  import Toasts from "./components/Toasts.svelte";
  import InputPrivacy from "./components/InputPrivacy.svelte";
  import Loading from "./components/Loading.svelte";
  import { tweened } from "svelte/motion";
  import { cubicOut } from "svelte/easing";
  import { onMount } from "svelte";
  import { result } from "./store.js";
  import { validateInput, validateInfo } from "./validate";

  const progress = tweened(1, {
    duration: 400,
    easing: cubicOut,
  });

  let isPreview = false;
  let isSingle = false;
  let current = 0;
  let path = "";
  let lang = "en";
  let info = {};
  let isLoading = true;
  let error = false;
  let privacyAccepted = false;
  let privacyError = false;
  let items = [];
  let currentErrors = false;

  //function to set and validate global data as state
  function setData(data, questionIndex) {
    isLoading = false;
    info = validateInfo(data);
    document.title = info.title + " | Walink";
    //Going to some point in the process with questionIndex
    if (
      questionIndex &&
      typeof questionIndex === "number" &&
      questionIndex > 0
    ) {
      current = questionIndex;
      // items = info.inputs.slice(0, questionIndex + 1);
      items = [info.inputs[questionIndex]];
      if (info.inputs.length > 0) {
        $progress = parseInt((questionIndex + 1 / info.inputs.length) * 100);
      }
    } else {
      items = info.inputs.length > 0 ? [info.inputs[0]] : [];
      if (info.inputs.length > 0) {
        $progress = parseInt((1 / info.inputs.length) * 100);
      }
    }
  }

  onMount(async () => {
    path = window.location.pathname.replace("/", "");
    const browserLang = window.navigator.language.slice(0, 2);
    lang = browserLang === "es" ? "es" : "en";
    if (!path) {
      const queryString = window.location.search;
      if (queryString) {
        const urlParams = new URLSearchParams(queryString);
        const title = urlParams.get("title");
        const titleColor = urlParams.get("titleColor");
        const description = urlParams.get("description");
        const textColor = urlParams.get("textColor");
        const background = urlParams.get("background");
        const image = urlParams.get("image");
        const buttonColor = urlParams.get("buttonColor");
        const progressColor = urlParams.get("progressColor");
        const stringInputs = urlParams.get("inputs");
        const privacy = urlParams.get("privacy");
        const submit = urlParams.get("submit");
        const questionIndex = urlParams.get("questionIndex");
        const single = urlParams.get("single");
        const jsonInputs = JSON.parse(stringInputs);
        let data = {
          title,
          titleColor,
          textColor,
          description,
          background,
          image,
          buttonColor,
          progressColor,
          privacy,
          submit: submit === "true",
          inputs: jsonInputs,
        };
        isPreview = true;
        isSingle = single === "true";
        let index = questionIndex ? parseInt(questionIndex) : null;
        setData(data, index);
      } else {
        return (window.location.href =
          lang === "es"
            ? "https://crear.wa.link/premium"
            : "https://create.wa.link/premium");
      }
    } else {
      try {
        let formUrl = `https://formlink.wa.link/${path}`;
        if (document.referrer) {
          formUrl += `/?ref=${encodeURIComponent(document.referrer)}`;
        }
        const response = await fetch(formUrl);
        if (response.ok) {
          const data = await response.json();
          setData(data);
        } else {
          window.location.href = "https://oops.wa.link/" + path;
        }
      } catch (e) {
        console.log(e.message);
        error = true;
      }
    }
  });

  function next(e) {
    if (isSingle) return;
    items = [...items, info.inputs[e.detail.nextIndex]];
    current++;
    $progress = parseInt(((current + 1) / info.inputs.length) * 100);
  }

  async function handleSubmit() {
    let resultString = "";
    let resultArray = [];
    if (isPreview) return;
    currentErrors = false;
    //loop through items, check errors, set item.errors a prop in component
    for (const [key, value] of Object.entries($result)) {
      if (!items[key].required && !value) continue;
      //if is time input, and both fields are empty, do not check for errors
      if (
        !items[key].required &&
        items[key].type === "time" &&
        !value.hour &&
        !value.minute
      )
        continue;
      items[key].errors = [];
      let errors = validateInput(info.inputs[key], value, lang);
      if (errors.length > 0) {
        items[key].errors = errors;
        currentErrors = true;
      }
      //if is a time input, we select the time property which is full time
      if (items[key].type === "time") {
        resultString += `*${info.inputs[key].title}:* ${value.time}\n`;
        resultArray.push({
          id: info.inputs[key].id,
          title: info.inputs[key].title,
          value: value.time,
        });
      } else {
        //here to construct the object
        resultArray.push({
          id: info.inputs[key].id,
          title: info.inputs[key].title,
          type: info.inputs[key].type,
          value: value,
        });
        resultString += `*${info.inputs[key].title}:* ${value}\n`;
      }
    }
    resultString = info.startMessage + "\n\n" + resultString;
    if (info.privacy && !privacyAccepted) {
      privacyError = true;
      return;
    } else {
      privacyError = false;
    }
    if (!currentErrors) {
      if (info.submit) {
        const data = JSON.stringify(resultArray);
        let formUrl = `https://formlink.wa.link/${path}`;
        if (document.referrer) {
          formUrl += `/?ref=${encodeURIComponent(document.referrer)}`;
        }
        navigator.sendBeacon(formUrl, data);
      }

      let redirect = `https://api.whatsapp.com/send?phone=${
        info.countryCode + info.phone
      }&text=${encodeURIComponent(resultString)}`;
      if (window.location !== window.parent.location) {
        // The page is inside an iframe
        window.top.location.href = redirect;
      } else {
        // The page is not inside an iframe
        window.location.href = redirect;
      }
    }
  }
</script>

<Loading {isLoading} {error} {lang}>
  <div
    class="main-container"
    style="background:{info.background || '#fafafa'};"
  >
    <main id="main">
      <form on:submit|preventDefault={handleSubmit} class="container">
        <button
          type="submit"
          disabled
          style="display: none"
          aria-hidden="true"
        />
        {#if !isSingle}
          <div class="info" style="color: {info.textColor || 'black'}">
            <Logo logo={info.image} title={info.title} />
            <h2 style="color: {info.titleColor || 'black'}">{info.title}</h2>
            <p>{info.description}</p>
          </div>
        {/if}
        <div class="items">
          {#each items as item, index}
            <Input
              {item}
              on:next={next}
              {index}
              total={info.inputs.length}
              {current}
              errors={item.errors || []}
              buttonColor={info.buttonColor || "#000"}
              {isSingle}
              {lang}
            />
          {/each}
        </div>
        {#if current + 1 >= info.inputs.length && !isSingle}
          {#if info.privacy}
            <InputPrivacy
              title={info.title || ""}
              submit={info.submit || false}
              error={privacyError}
              privacy={info.privacy}
              on:accept={(e) => (privacyAccepted = e.detail.accepted)}
              {lang}
            />
          {/if}
          <button type="submit" class="btn primary">
            <WhatsApp />

            <span
              >{lang === "es"
                ? "Enviar por WhatsApp"
                : "Submit on WhatsApp"}</span
            >
          </button>
        {/if}
      </form>
      <Toasts {items} />
    </main>
    <div class="progress-bar">
      <div
        class="progress"
        style="--theme-width: {$progress}%; background:{info.progressColor ||
          '#000'}"
      />
    </div>
  </div>
</Loading>

<style>
  main {
    text-align: center;
    padding: 1rem;
    max-width: 400px;
    margin: 0 auto;
    min-height: 100vh;
  }
  .main-container {
    width: 100%;
  }
  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .items {
    margin-top: 10px;
    width: 100%;
  }
  p {
    text-align: center;
    font-size: 15px;
  }
  .btn span {
    padding-bottom: 2px;
  }
  .btn {
    margin-bottom: 2rem;
  }

  .progress-bar {
    position: fixed;
    bottom: 0;
    height: 10px;
    width: 100%;
    background-color: #eee;
  }
  .progress {
    width: var(--theme-width);
    height: 100%;
    background-color: #000;
  }
  /* @media (min-width: 640px) {
    main {
      max-width: none;
    }
  } */
</style>
